/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();

'use strict';
const Preloader = {
	/**
	 * @description Cache dom and strings
	 * @description Please always define selectors, classes and data attributes with the following prefixes
	 * @type {object}
	 * @param {jQuery} $dom     for any jQuery selectors    - example: $domMenu: $('.js-menu')
	 * @param {string} sl       for any string selectors    - example: slMenu: '.js-menu'
	 * @param {string} class    for any class strings       - example: classActive: 'is-active'
	 * @param {string} attr     for any attributes strings  - example: attrIndex: 'data-index'
	 */

	$domLoaderSelector: $('.js-load-more'),

	/**
	 * @description Initialize
	 * @example this.someFunction();
	 */
	init: function() {
		this.bindEvents();
		$('.drops__nav-item-sub').on('click', function() {
			$('.drops__nav-item-sub').removeClass('sub-active');
			$(this).addClass('sub-active');

		});
		$('.js-drops__nav-item-title').on('click', function() {
			$('.drops__nav-item-sub').removeClass('sub-active');
			$(this).next().find('li').first().addClass('sub-active');
		});
	},

	bindEvents: function() {
		$('.js-load-more').on('click', function() {
			$('.js-loader').addClass('drops__loader');
			setTimeout(function(){
				$('.js-loader').removeClass('drops__loader');
			}, 1000);
		});

		$('.drops__nav-item-link').on('click', function() {
			$('.drops__loader').addClass('drops__loader-wrapp');
			setTimeout(function(){
				$('.drops__loader').removeClass('drops__loader-wrapp');
			}, 1000);
		});
	},
};

export default Preloader;
